export const Y_MAP_API_KEY = '7f467af6-be87-4c34-9f26-8b288486978c'